import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Badge } from './shared';

export default function ProductsCard({ data, overview }) {
  const { t } = useTranslation();
  return (
    <Card title={t('productsCard.title')} icon="⚙️">
      {overview.problem && (
        <div style={s.problem}>
          <span style={s.problemLabel}>{t('productsCard.problem')}</span>
          <p style={s.problemText}>{overview.problem}</p>
        </div>
      )}
      {data.core && (
        <div style={s.section}>
          <span style={s.sectionLabel}>{t('productsCard.core')}</span>
          <p style={s.sectionText}>{data.core}</p>
        </div>
      )}
      {data.techStack && (
        <div style={s.section}>
          <span style={s.sectionLabel}>Tech Stack</span>
          <p style={s.sectionText}>{data.techStack}</p>
        </div>
      )}
      {data.differentiator && (
        <div style={s.diffBox}>
          <span style={s.diffLabel}>⚡ {t('productsCard.differentiator')}</span>
          <p style={s.diffText}>{data.differentiator}</p>
        </div>
      )}

      {(data.completed.length + data.inProgress.length + data.upcoming.length) > 0 && (
        <div style={s.roadmap}>
          <span style={s.roadLabel}>{t('productsCard.roadmapStatus')}</span>
          <div style={s.roadItems}>
            {data.completed.map((m, i) => (
              <div key={`c${i}`} style={s.roadItem}>
                <span style={{ ...s.roadIcon, background: 'rgba(5,150,105,0.12)' }}>✅</span>
                <span style={s.roadText}>{m}</span>
              </div>
            ))}
            {data.inProgress.map((m, i) => (
              <div key={`p${i}`} style={s.roadItem}>
                <span style={{ ...s.roadIcon, background: 'rgba(31,88,164,0.12)' }}>🔄</span>
                <span style={{ ...s.roadText, color: '#1f58a4' }}>{m}</span>
              </div>
            ))}
            {data.upcoming.map((m, i) => (
              <div key={`u${i}`} style={s.roadItem}>
                <span style={{ ...s.roadIcon, background: 'rgba(217,119,6,0.12)' }}>📅</span>
                <span style={{ ...s.roadText, color: '#d97706' }}>{m}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={s.links}>
        {overview.website && overview.website !== 'N/A' && (
          <a href={overview.website} target="_blank" rel="noreferrer" style={s.link}>🌐 {t('productsCard.website')} ↗</a>
        )}
        {overview.whitepaper && !/not public/i.test(overview.whitepaper) && (
          <a href={overview.whitepaper} target="_blank" rel="noreferrer" style={s.link}>📄 {t('productsCard.whitepaper')} ↗</a>
        )}
      </div>
    </Card>
  );
}

const s = {
  problem: {
    background: 'rgba(31,88,164,0.07)', border: '1px solid rgba(31,88,164,0.2)',
    borderRadius: 10, padding: '12px 14px', marginBottom: 12,
  },
  problemLabel: { fontSize: 10, color: '#1f58a4', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.8, display: 'block', marginBottom: 5 },
  problemText: { fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.6, margin: 0, wordBreak: 'break-word', overflowWrap: 'break-word' },
  section: { marginBottom: 12 },
  sectionLabel: { fontSize: 10, color: 'var(--text-muted)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.8, display: 'block', marginBottom: 5 },
  sectionText: { fontSize: 12, color: 'var(--text-dim)', lineHeight: 1.6, margin: 0, wordBreak: 'break-word', overflowWrap: 'break-word' },
  diffBox: {
    background: 'rgba(124,58,237,0.07)', border: '1px solid rgba(124,58,237,0.2)',
    borderRadius: 10, padding: '12px 14px', marginBottom: 12,
  },
  diffLabel: { fontSize: 10, color: '#7c3aed', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.8, display: 'block', marginBottom: 5 },
  diffText: { fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.6, margin: 0, wordBreak: 'break-word', overflowWrap: 'break-word' },
  roadmap: { marginBottom: 12 },
  roadLabel: { fontSize: 10, color: 'var(--text-muted)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.8, display: 'block', marginBottom: 8 },
  roadItems: { display: 'flex', flexDirection: 'column', gap: 6 },
  roadItem: { display: 'flex', alignItems: 'flex-start', gap: 8, minWidth: 0 },
  roadIcon: { width: 24, height: 24, borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, flexShrink: 0 },
  roadText: { fontSize: 12, color: '#059669', lineHeight: 1.5, paddingTop: 3, wordBreak: 'break-word', overflowWrap: 'break-word', minWidth: 0 },
  links: { display: 'flex', gap: 10, marginTop: 8, flexWrap: 'wrap' },
  link: {
    fontSize: 12, color: '#1f58a4', background: 'rgba(31,88,164,0.08)',
    border: '1px solid rgba(31,88,164,0.2)', borderRadius: 8, padding: '6px 12px',
    textDecoration: 'none', fontWeight: 600,
  },
};
